"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormattedDuration = function FormattedDuration(_ref) {
  var className = _ref.className,
      value = _ref.value,
      showSeconds = _ref.showSeconds;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedNumber, {
    value: Math.floor(value / 60 / 60 / 24),
    maximumFractionDigits: 0
  }, function (number) {
    return number > 0 && "".concat(number, "d ");
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedNumber, {
    value: Math.floor(value / 60 / 60) % 24,
    maximumFractionDigits: 0
  }, function (number) {
    return number > 0 && "".concat(number, "h ");
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedNumber, {
    value: Math.floor(value / 60) % 60,
    maximumFractionDigits: 0
  }, function (number) {
    return number > 0 && "".concat(number, "min ");
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedNumber, {
    value: value % 60,
    maximumFractionDigits: 0
  }, function (number) {
    return number > 0 && showSeconds && "".concat(number, "s");
  }));
};

FormattedDuration.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].number,
  showSeconds: _propTypes["default"].bool
};
FormattedDuration.defaultProps = {
  className: '',
  value: 0,
  showSeconds: false
};
var _default = FormattedDuration;
exports["default"] = _default;